import React from 'react';
import ReminderHour from './ReminderHour'

import '../../App.css';
import '../../bootstrap.css';

export default class ReminderDay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
      return (
        <span>
          <ul>
            {Object.keys(this.props.dayItems).map((hour) =>
              <li key={hour}>
                <b>Hour {hour}</b>
                <ReminderHour hour={hour} hourItems={this.props.dayItems[hour]} userName={this.props.userName}
                    path={this.props.path + '/' + hour} firebase={this.props.firebase} refresh={this.props.refresh}
                    workoutsMap={this.props.workoutsMap} dailyHabitsMap={this.props.dailyHabitsMap}
                    weeklyHabitsMap={this.props.weeklyHabitsMap} hideDisabled={this.state.hideDisabled}/>
              </li>
            )}
          </ul>
        </span>
      )
    }
}


// WEBPACK FOOTER //
// ./src/main/reminders/ReminderDay.js